import { render, staticRenderFns } from "./diyservice.vue?vue&type=template&id=13c1f058&scoped=true&"
import script from "./diyservice.vue?vue&type=script&lang=js&"
export * from "./diyservice.vue?vue&type=script&lang=js&"
import style0 from "./diyservice.vue?vue&type=style&index=0&id=13c1f058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1f058",
  null
  
)

export default component.exports